// Haunted House rooms as string maps. 17 x 11 tiles each.
// Legend: # wall  . floor  r rug  D door (on an edge)  L locked door (needs a key)  K key
//         T torch (lights a dark room)  C crate (pushable)  S switch (crate on it opens B)
//         B barrier (opens with the switch)  ? challenge door (answer a question)  X chest

export const TILE = { FLOOR: 0, WALL: 1, DOOR: 2, LOCKED: 3, KEY: 4, TORCH: 5, CRATE: 6, SWITCH: 7, CHEST: 8, QDOOR: 9, BARRIER: 10, RUG: 11, TORCH_LIT: 12 } as const;

export const LEGEND: Record<string, number> = {
  '.': TILE.FLOOR, '#': TILE.WALL, 'D': TILE.DOOR, 'L': TILE.LOCKED, 'K': TILE.KEY, 'T': TILE.TORCH,
  'C': TILE.CRATE, 'S': TILE.SWITCH, 'X': TILE.CHEST, '?': TILE.QDOOR, 'B': TILE.BARRIER, 'r': TILE.RUG,
};

export const SOLID = [TILE.WALL, TILE.LOCKED, TILE.CRATE, TILE.CHEST, TILE.QDOOR, TILE.BARRIER];

export interface GhostDef { path: [number, number][]; speed: number }   // tile waypoints
export interface Room {
  id: string;
  name: string;
  dark?: boolean;
  rows: string[];
  exits: { left?: string; right?: string; up?: string; down?: string };
  ghosts?: GhostDef[];
}

export const ROOMS: Room[] = [
  {
    id: 'hall', name: 'The Hall',
    rows: [
      '#######D#########',
      '#.....#?#.......#',
      '#..rrr.....rrr..#',
      '#..rrr.....rrr..#',
      '#...............#',
      '#...............D',
      '#...............#',
      '#..rrr.....rrr..#',
      '#..rrr.....rrr..#',
      '#...............#',
      '#################',
    ],
    exits: { right: 'kitchen', up: 'library' },
  },
  {
    id: 'kitchen', name: 'The Kitchen', dark: true,
    rows: [
      '#################',
      '#......#........#',
      '#..T...#....K.###',
      '#......#........#',
      '#......#........#',
      'D......#.......LD',
      '#......#.......##',
      '#...............#',
      '#...............#',
      '#...............#',
      '#################',
    ],
    exits: { left: 'hall', right: 'cellar' },
    ghosts: [{ path: [[2, 8], [14, 8]], speed: 2.2 }],
  },
  {
    id: 'library', name: 'The Library',
    rows: [
      '#################',
      '#...............#',
      '#..#####.#####..#',
      '#..#.K.B........#',
      '#..#####........#',
      '#.......S.......#',
      '#...............#',
      '#......C........#',
      '#...............#',
      '#...............#',
      '#######D#########',
    ],
    exits: { down: 'hall' },
  },
  {
    id: 'cellar', name: 'The Cellar', dark: true,
    rows: [
      '########D########',
      '#......#?#......#',
      '#...............#',
      '#....#######....#',
      '#....#.....#....#',
      'D....#..T..#....#',
      '#....#.....#....#',
      '#....###.###....#',
      '#...............#',
      '#...............#',
      '#################',
    ],
    exits: { left: 'kitchen', up: 'attic' },
    ghosts: [{ path: [[2, 2], [14, 2], [14, 9], [2, 9]], speed: 2.6 }],
  },
  {
    id: 'attic', name: 'The Attic',
    rows: [
      '#################',
      '#...............#',
      '#.....#####.....#',
      '#.....#.X.#.....#',
      '#.....#...#.....#',
      '#.....##L##.....#',
      '#...............#',
      '#...............#',
      '#...............#',
      '#...............#',
      '########D########',
    ],
    exits: { down: 'cellar' },
    ghosts: [{ path: [[2, 7], [14, 7]], speed: 1.8 }],
  },
];

export const ROOM_BY_ID: Record<string, Room> = Object.fromEntries(ROOMS.map(r => [r.id, r]));
export const START_ROOM = 'hall';
export const START_POS: [number, number] = [8, 6];
